var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFirstWordsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.2 5.2H23.8C26.4 5.2 28.5 7.3 28.5 9.9V18.3C28.5 20.9 26.4 23 23.8 23H14.6L8.9 27.4C8.4 27.8 7.7 27.4 7.7 26.8V23C5.3 22.8 3.5 20.8 3.5 18.3V9.9C3.5 7.3 5.6 5.2 8.2 5.2Z",
    stroke: "#CD8F6C",
    strokeWidth: 1.15,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 13.1C10.5 12.2 11.3 12.2 12.2 13.1C13.1 14 13.9 14 14.8 13.1",
    stroke: "#CD8F6C",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2 13.1C18.1 12.2 18.9 12.2 19.8 13.1C20.7 14 21.5 14 22.4 13.1",
    stroke: "#CD8F6C",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4 17.4H20.6",
    stroke: "#CD8F6C",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6 1.6L26.1 3L27.5 3.5L26.1 4L25.6 5.4L25.1 4L23.7 3.5L25.1 3L25.6 1.6Z",
    fill: "#CD8F6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstWordsIcon);
export default __webpack_public_path__ + "static/media/firstWordsIcon.4b4e7f9630599383511519307dd3ca4c.svg";
export { ForwardRef as ReactComponent };